import {
  TooltipContent,
  Tooltip as TooltipRoot,
  TooltipTrigger,
} from '#/components/ui/tooltip';
import { TooltipTriggerProps } from '@radix-ui/react-tooltip';
import { ReactNode } from 'react';

export interface TooltipProps extends Omit<TooltipTriggerProps, 'content'> {
  children?: ReactNode;
  content?: ReactNode;
}
export function Tooltip({ children, content, ...props }: TooltipProps) {
  return (
    <TooltipRoot>
      <TooltipTrigger type="button" {...props}>
        {children}
      </TooltipTrigger>
      <TooltipContent className="max-w-xl">{content}</TooltipContent>
    </TooltipRoot>
  );
}
